'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    AppDispatcher = require('../AppDispatcher'),
    NotificationActionCreators = require('../actions/NotificationActionCreators'),
    Messages = require('../constants/NotificationMessages');

var InvitationServerActionCreators = {
  handleAddToGrabbag(err, response, uuid, stampId) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.IMAGE_ADD_TO_GRABBAG_ERROR : ActionTypes.IMAGE_ADD_TO_GRABBAG_SUCCESS,
      response: response,
      uuid: uuid,
      stampId: stampId
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.showNotification(Messages.IMAGE_ADDED_TO_GRABBAG);
    }
  },

  handleGrabbagImagesPage(err, response, tab) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_GRABBAG_IMAGES_ERROR : ActionTypes.REQUEST_GRABBAG_IMAGES_SUCCESS,
      response: response,
      tab: tab
    });

    if (err) {
      console.error(err);
    }
  },

  handleRemoveFromGrabbag(err, response, uuid) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.IMAGE_REMOVE_FROM_GRABBAG_ERROR : ActionTypes.IMAGE_REMOVE_FROM_GRABBAG_SUCCESS,
      response: response,
      uuid: uuid
    });

    if (err) {
      console.error(err);
    }
  },

  handleRemoveStampletItem(err, response, uuid) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM_ERROR : ActionTypes.IMAGE_REMOVE_STAMPLET_ITEM_SUCCESS,
      response: response,
      uuid: uuid
    });

    if (err) {
      console.error(err);
    }
  },

  handleImageUsedInStampsPage(err, response, imageUuid) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS_ERROR : ActionTypes.REQUEST_IMAGE_USED_IN_STAMPS_SUCCESS,
      response: response,
      imageUuid: imageUuid
    });

    if (err) {
      console.error(err);
    }
  }
};

module.exports = InvitationServerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/ImageServerActionCreators.js
 **/